// Generated types for Invite
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { InviteStatus } from '../../shared/enums';

import { PrivateNodeReadAPI, PrivateNodeWriteAPI } from '../../shared/types/privatenode';
import { PrivateNodeReadAPISchemaObject, PrivateNodeWriteAPISchemaObject } from '../../shared/types/privatenode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InviteReadAPI extends PrivateNodeReadAPI {
  /** Invited email (lowercased at write) */
  email: string;
  /** Exact group joined on acceptance; server-set by the group invitation route */
  target_group_id?: string | null;
  /** Standard role granted on acceptance (any invitable role of the scope kind; never the owner tier). */
  role?: string | null;
  /** pending / accepted / declined / revoked */
  status?: InviteStatus;
  /** Token/invite expiry (server-set, 14 days) */
  expires_at?: string | null;
  /** Identifier of the ACCEPTING account (audit — may differ from the invited email on the token path) */
  accepted_by?: string;
  /** Last email send (resend rate-limit basis) */
  last_sent_at?: string | null;
  /** User node id of the inviting user (server-set; never a sign-in identifier, A7) */
  created_by?: string;
  /** Invite timestamp (server-set) */
  created_at?: string | null;
}

export interface InviteWriteAPI extends PrivateNodeWriteAPI {
  /** Invited email (lowercased at write) */
  email: string;
  /** Standard role granted on acceptance (any invitable role of the scope kind; never the owner tier). */
  role?: string | null;
  /** pending / accepted / declined / revoked */
  status?: InviteStatus;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InviteReadAPISchema: z.ZodType<InviteReadAPI> = PrivateNodeReadAPISchemaObject.extend({
  email: z.string(),
  target_group_id: z.string().nullable().optional(),
  role: z.string().nullable().optional(),
  status: z.nativeEnum(InviteStatus).optional(),
  expires_at: z.string().nullable().optional(),
  accepted_by: z.string().optional(),
  last_sent_at: z.string().nullable().optional(),
  created_by: z.string().optional(),
  created_at: z.string().nullable().optional(),
}).passthrough();

export const InviteWriteAPISchema: z.ZodType<InviteWriteAPI> = PrivateNodeWriteAPISchemaObject.extend({
  email: z.string(),
  role: z.string().nullable().optional(),
  status: z.nativeEnum(InviteStatus).optional(),
}).passthrough();
